<template>
  <div class="container-fluid">
    <multiple-choice-edit-option-sidebar 
      :isSidebarActive="isEditOptionSidebarActive" 
      @closeSidebar="toggleEditOptionSidebar" 
      :data="editOptionSidebarData" />

    <h5>Multiple Choice</h5>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Allow Multiple Answers</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="question.configMultipleChoice" v-model="question.configMultipleChoice.allowMultipleAnswers"/>
      </div>
    </div>
  
    <vs-table
      v-if="question.configMultipleChoice"
      ref="table"
      class="mt-8"
      :data="this.question.configMultipleChoice.options"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div
            @click="addOption"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add Option</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="text">Answer</vs-th>
        <vs-th sort-key="isCorrect">Is Correct</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ $translate(tr.text) }}</p>
            </vs-td>

            <vs-td>
              <p class="status-category">
                <vs-chip :color="getCorrectColor(tr.isCorrect)" class="status-circle"></vs-chip>
                {{ tr.isCorrect | yesno }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr, indextr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(indextr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import MultipleChoiceEditOptionSidebar from './MultipleChoiceEditOptionSidebar.vue'

export default {
  name: "QuestionConfigMultipleChoice",
  components: {
    MultipleChoiceEditOptionSidebar
  },
  directives: {
  },
  props: ['question'],
  data() {
    return {
      isEditOptionSidebarActive: false,
      editOptionSidebarData: {
        text: '',
        isCorrect: false
      },

      itemsPerPage: 100,
      isMounted: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    }
  },
  methods: {
    addOption() {
      this.editOptionSidebarData = {
        text: '',
        isCorrect: false,

        isSubmitted: false,
        isNewOption: true,
        index: -1
      };

      this.isEditOptionSidebarActive = true;
    },

    toggleEditOptionSidebar() {
      this.isEditOptionSidebarActive = !this.isEditOptionSidebarActive;

      if (this.editOptionSidebarData.isSubmitted === false) {
        return;
      }

      // Add or update option
      if (this.editOptionSidebarData.isNewOption === true) {
        this.question.configMultipleChoice.options.push({
          text: this.editOptionSidebarData.text,
          isCorrect: this.editOptionSidebarData.isCorrect
        });
      } else {
        this.question.configMultipleChoice.options[this.editOptionSidebarData.index] = {
          text: this.editOptionSidebarData.text,
          isCorrect: this.editOptionSidebarData.isCorrect
        };

        const clonedOptions = this.question.configMultipleChoice.options.slice();

        this.question.configMultipleChoice.options = clonedOptions;
      }
    },

    deleteData(index) {
      console.log("deleteData");
      this.question.configMultipleChoice.options.splice(index, 1);
    },

    editData(data, index) {
      this.editOptionSidebarData = {
        text: data.text,
        isCorrect: data.isCorrect,

        isSubmitted: false,
        isNewOption: false,
        index: index
      };

      this.isEditOptionSidebarActive = true;
    },

    getCorrectColor(isCorrect) {
      if (isCorrect === true) return "success";
      return "danger";
    },
  },
  mounted() {
    this.isMounted = true;

    console.log("Mounted");
    console.log(this.question);
    console.log(this.question.configMultipleChoice);

    if (!this.question.configMultipleChoice || this.question.configMultipleChoice === null) {
        this.question.configMultipleChoice = {
            options: [],
            allowMultipleAnswers: false
        };
    }
  },
  beforeDestroy: function() {
  }
};
</script>